<template>
  <div class="faq-components">
    <div class="faq">
      <div class="jumbotron">
        <img src="../assets/img/faq/jumbotron.jpg" alt="" class="over_display">
        <img src="../assets/img/faq/jumbotron_under.jpg" alt="" class="under_display">
      </div>
      <div class="catch-wrapper">
        <img src="../assets/img/faq/catch.png" alt="学生のみなさんから寄せられる質問のベスト4を発表します。" width="450px">
      </div>
      <div class="main-contents-wrapper">
        <FaqContent number="1" question="「キャリアステップはどうなっていますか？」" answer="基本は、現場で店長を目指していただきます。" >
          <p class="faq-answer-content">
            入社1年目からの標準的なキャリアステップは以下の通りです。<br>
            ---------------------------<br>
            1〜3年目／現場担当者<br>
            <i class="pink">▼</i><br>
            3〜5年目／チーフ<br>
            <i class="pink">▼</i><br>
            8〜10年目／店長代行<br>
            <i class="pink">▼</i><br>
            13年目以降／店長<br>
            ---------------------------<br>
            チーフや店長代行になった後、<br class='under_display'>
            本部に異動する場合もあります。<br>
            実力次第で入社3年目で採用担当になる、<br class='under_display'>
            また4年目でバイヤーになるなど、<br>
            若手から本部に配属される社員もいます。<br>
            つまり、明確に「何年でこうなれる」という<br class='under_display'>
            キャリアステップは、<br>
            sanwaにはありません。<br>
            すべては、ご本人の努力と結果次第です。
          </p>
        </FaqContent>
        <FaqContent number="2" question="「今後、全国展開は行いますか？」" answer="まったく考えておりません。" >
          <p class="faq-answer-content">
            2019年10月、私たちはこれまでの<br>
            東京都、神奈川県にくわえて静岡県沼津に進出。<br>
            ただし、この他のエリアで出店をする予定はありません。<br>
            若手社員が沼津に配属になることもないため、<br>
            希望する方は、東京・神奈川で勤務することが可能です。
          </p>
        </FaqContent>
        <FaqContent number="3" question="「異動はどのくらいのペース？」" answer="人により異なりますが、希望にも応じます。" >
          <p class="faq-answer-content">
            異動のペースは人それぞれ。<br>
            半年で異動する人もいれば、<br class='under_display'>
            同じ店舗で数年にわたって働く人もいます。<br>
            これは、本部や上司が社員一人ひとりの適性を見て<br class='under_display'>
            判断しているからです。<br>
            なお、本人から「異動したい」という申告があれば、<br class='under_display'>
            人事が対応します。
          </p>
        </FaqContent>
        <FaqContent number="4" question="「住宅に関するサポートはありますか？」" answer="福利厚生の一環で用意しています。" >
          <p class="faq-answer-content">
            寮については、男子寮のみあります<br class='under_display'>
            （月2万2000円・朝・晩の食事あり）。<br>
            女子寮も以前は存在しましたが、<br class='under_display'>
            希望者の減少を受け数年前に終了しました。<br>
            社宅は、チーフ職以上の既婚者であれば入居できます。<br>
            住宅手当は、基本給に組み込んだかたちで支給しています。
          </p>
        </FaqContent>
      </div>
    </div>
  </div>
</template>

<script>
import FaqContent from '@/components/faq/FaqContent.vue'
export default {
  name: 'Faq',
  components: {
    FaqContent
  }
}
</script>
<style scoped lang="scss">
.faq {
  padding-bottom: 100px;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
  img {
    vertical-align: middle;
  }
}
.catch-wrapper {
  margin: 0 auto;
  max-width: 900px;
  width: 100%;
  margin-top: -100px;
  text-align: right;
  @media print, screen and (max-width: 750px) {
    margin-top: -10px;
    width: 90%;
  }
}
.main-contents-wrapper {
  max-width: 900px;
  margin: 0 auto;
  margin-top: 100px;
  @media print, screen and (max-width: 900px) {
    width: 90%;
    margin-top: 50px;
  }
  .pink {
    color: #e51c57;
    font-style: normal;
    margin-left: 1em;
  }
  .faq-answer-content {
    font-size: 12px;
    line-height: 2em;
  }
}
</style>
